<template>
  <v-card outlined class="ma-2" elevation="2">
    <v-card-title class="text-h5 title-header">{{
      $t("llm_config.escalation_manager.title")
    }}</v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="12" md="8">
          <v-card outlined class="mb-2">
            <v-card-title>
              {{ $t("llm_config.escalation_manager.is_escalation_check.name") }}
            </v-card-title>
            <v-card-subtitle>
              {{ $t("llm_config.escalation_manager.is_escalation_check.hint") }}
            </v-card-subtitle>
            <v-card-text>
              <v-switch
                class="my-0 py-0"
                v-model="is_escalation"
                :rules="form_roles.booleanField"
                @change="handle_is_escalation"
                hide-details
              ></v-switch>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" md="8">
          <v-card outlined class="mb-2">
            <v-card-title>
              {{ $t("llm_config.escalation_manager.is_escalation_agent.name") }}
            </v-card-title>
            <v-card-subtitle>
              {{ $t("llm_config.escalation_manager.is_escalation_agent.hint") }}
            </v-card-subtitle>
            <v-card-text outlined>
              <v-switch
                class="my-0 py-0"
                v-model="is_escalation_agent"
                :rules="form_roles.booleanField"
                :disabled="!is_escalation_check"
                hide-details
              >
                <template v-if="!is_escalation_check" v-slot:label>
                  <span class="red--text font-weight-bold caption">
                    {{
                      $t(
                        "llm_config.escalation_manager.is_escalation_agent.label"
                      )
                    }}
                  </span>
                </template></v-switch
              >
            </v-card-text>
          </v-card>
        </v-col> -->
        <v-col cols="12" md="8">
          <v-card outlined class="mb-2">
            <v-card-title>
              {{
                $t("llm_config.escalation_manager.is_escalation_summarize.name")
              }}
            </v-card-title>
            <v-card-subtitle>
              {{
                $t("llm_config.escalation_manager.is_escalation_summarize.hint")
              }}
            </v-card-subtitle>
            <v-card-text outlined>
              <v-switch
                class="my-0 py-0"
                v-model="is_escalation_summarize"
                :rules="form_roles.booleanField"
                :disabled="!is_escalation"
                hide-details
              >
                <template v-if="!is_escalation" v-slot:label>
                  <span class="caption">
                    {{
                      $t(
                        "llm_config.escalation_manager.is_escalation_summarize.label"
                      )
                    }}
                  </span>
                </template>
              </v-switch>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EscalationManager",
  data() {
    return {
      is_escalation: false,
    };
  },
  props: {
    openaiConfig: {
      type: Object,
      required: true,
    },
    form_roles: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    //set default values if they don't exist
    if (!this.openaiConfig?.langchain_settings?.is_escalation_check) {
      this.$set(
        this.openaiConfig.langchain_settings,
        "is_escalation_check",
        false
      );
    }
    if (!this.openaiConfig?.langchain_settings?.is_escalation_agent) {
      this.$set(
        this.openaiConfig.langchain_settings,
        "is_escalation_agent",
        false
      );
    }
    if (!this.openaiConfig?.langchain_settings?.is_escalation_summarize) {
      this.$set(
        this.openaiConfig.langchain_settings,
        "is_escalation_summarize",
        false
      );
    }
    if (this.is_escalation_check && this.is_escalation_agent) {
      this.is_escalation = true;
    }
  },
  computed: {
    is_escalation_check: {
      get() {
        return this.openaiConfig.langchain_settings.is_escalation_check;
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "is_escalation_check",
          value
        );
      },
    },
    is_escalation_agent: {
      get() {
        return this.openaiConfig.langchain_settings.is_escalation_agent;
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "is_escalation_agent",
          value
        );
      },
    },
    is_escalation_summarize: {
      get() {
        return this.openaiConfig.langchain_settings.is_escalation_summarize;
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "is_escalation_summarize",
          value
        );
      },
    },
  },
  methods: {
    handle_is_escalation(value) {
      this.is_escalation_check = value;
      this.is_escalation_agent = value;
      if (!value) {
        this.is_escalation_summarize = false;
      }
    },
  },
};
</script>

<style scoped>
.title-header {
  font-weight: bold;
  color: #1141ce; /* Vuetify primary color */
}
</style>
